import { createIcon } from '@chakra-ui/react';

export const Astro = createIcon({
  displayName: 'Astro',
  viewBox: '0 0 24 24',
  path: [
    <path
      d="M9.87,4.83c-0.73,0-1.32,0.6-1.32,1.35c0,0.75,0.59,1.35,1.32,1.35c0.73,0,1.32-0.6,1.32-1.35
    C11.19,5.44,10.6,4.83,9.87,4.83z"
    />,
    <path
      d="M14.05,4.83c-0.73,0-1.32,0.6-1.32,1.35c0,0.75,0.59,1.35,1.32,1.35c0.73,0,1.32-0.6,1.32-1.35
    C15.38,5.44,14.78,4.83,14.05,4.83z"
    />,
    <path
      d="M19.92,18.52l-1.29-6.76c-0.1-0.45-0.5-0.77-0.95-0.77h-3.85v-0.63h2.99c0.64,0,1.16-0.53,1.16-1.19V3.19
    c0-0.66-0.52-1.19-1.16-1.19H7.17C6.53,2,6.01,2.53,6.01,3.19v5.99c0,0.66,0.52,1.19,1.16,1.19h2.7V11H6.28
    c-0.47,0-0.87,0.34-0.96,0.81l-1.29,6.76C4.02,18.64,4,19.01,4,19.12v1.07c0,1,0.79,1.81,1.77,1.81h0.61
    c0.98,0,1.77-0.81,1.77-1.81v-0.45h7.7v0.45c0,1,0.79,1.81,1.77,1.81h0.61c0.98,0,1.77-0.81,1.77-1.81v-1.07
    C20,18.99,19.94,18.6,19.92,18.52z M6.99,9.18V3.19C6.99,3.08,7.07,3,7.17,3h9.65c0.1,0,0.19,0.08,0.19,0.19v5.99
    c0,0.1-0.08,0.19-0.19,0.19H7.17C7.07,9.37,6.99,9.28,6.99,9.18z M15.71,12v2.52c0,1.05-0.84,1.91-1.87,1.91h-3.71
    c-1.03,0-1.87-0.86-1.87-1.91V12H15.71z M6.28,12h1v2.52c0,1.6,1.28,2.91,2.85,2.91h3.71c1.57,0,2.85-1.3,2.85-2.91V12h0.99
    l1.3,6.75L5,18.75L6.28,12z M7.17,20.19c0,0.45-0.35,0.81-0.79,0.81H5.77c-0.44,0-0.79-0.36-0.79-0.81v-0.45c0.01,0,0.01,0,0.02,0
    h2.18V20.19z M18.23,21h-0.61c-0.44,0-0.79-0.36-0.79-0.81v-0.45h2.15c0.02,0,0.03,0,0.05-0.01v0.45
    C19.02,20.64,18.67,21,18.23,21z"
    />,
  ],
});
